import React, { useState } from "react";
import { DatePicker, Spin, Button, message } from "antd";
import { connect } from "react-redux";
import { saveNewCycleData } from "./fundingLimitActions";
import { push } from "connected-react-router";
import { getTranslate } from "react-localize-redux";
import { Row } from "antd";
import { withActions } from "actionware";
import { ACTION_MAPPING } from "./constants";
import moment from "moment";
import "./fundingLimit.less";

const SelectDate = ({ translate, loading, prevStepClicked, nextStepClicked, saveNewCycleData, newCycle }) => {
    const [scheduleDate, setScheduleDate] = useState(newCycle.scheduleDate);
  if (loading) {
    return <Spin tip={translate("generic.loadingData")} size="large" />;
  }

  const handleDateChange = (date) => {
    setScheduleDate(date);
  };

  const validateDate = () => {
    if (!scheduleDate) {
      message.error(translate("errorMessages.ovo_admin_error_select_date"));
      return;
    }

    saveNewCycleData(ACTION_MAPPING.saveScheduleDate, { scheduleDate: scheduleDate });
    nextStepClicked();
  };

  const renderButtonForNavigation = () => {
    return (
      <>
        <Button type="secondary" onClick={prevStepClicked}>
          {translate("fundingLimit.back")}
        </Button>
        <Button type="primary" onClick={validateDate}>
          {translate("fundingLimit.ovo_admin_button_confirm_allocation")}
        </Button>
      </>
    );
  };

  return (
    <div className="select-date-container">
      <Row>
        <DatePicker 
        onChange={handleDateChange}
        format="YYYY-MM-DD HH:mm"
        showTime={{ format: 'HH:mm' }}
        placeholder={translate("fundingLimit.ovo_admin_placeholder_select_date")}
        value={scheduleDate ? moment(scheduleDate) : null}
        disabledDate={(current) => current && current.isSameOrBefore(moment().endOf('day'))}
        minuteStep={15}
         />
      </Row>

      <Row>
        {renderButtonForNavigation()} 
      </Row>
    </div>
  );
};

const mapStateToProps = ({
  localize,
  funding: { action, newCycle },
}) => ({
  translate: getTranslate(localize),
  action,
  newCycle,
});

const mapDispatchToProps = (dispatch) => ({
  push: (path) => dispatch(push(path))
});

export default connect(mapStateToProps, mapDispatchToProps)(withActions({
  saveNewCycleData,
})(SelectDate));
